import { render } from "./advertisements.vue?vue&type=template&id=2923e340&scoped=true"
import script from "./advertisements.vue?vue&type=script&lang=js"
export * from "./advertisements.vue?vue&type=script&lang=js"

import "./advertisements.vue?vue&type=style&index=0&id=2923e340&scoped=true&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2923e340"]])

export default __exports__